import { SvgIcon } from '@mui/material'

import type { SvgIconProps } from '@mui/material'

export default function DropboxIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M3 6.2L8 9.39L13 6.2L8 3L3 6.2M13 6.2L18 9.39L23 6.2L18 3L13 6.2M3 12.55L8 15.74L13 12.55L8 9.35L3 12.55M18 9.35L13 12.55L18 15.74L23 12.55L18 9.35M8.03 16.8L13.04 20L18.04 16.8L13.04 13.61L8.03 16.8Z" />
    </SvgIcon>
  )
}
